import React, { useState } from "react";
import {
    Button,
    Modal,
    Form,
    Input,
    Select,
    DatePicker,
    Upload,
    message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { useParams } from "react-router-dom";
import { Alert } from "antd";
import useCandidateStore from "../../../store/candidateModal.store";
import useResumeStore from "../../../store/resume.store";

import "./nujobsResumeAddModal.scss";
import { API_URL } from "../../../helper/axioscontants";
import useNuJobsResumeAddModalStore from "../../../store/nujobsResuneAddModal.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";

export default function NuJobsResumeAddModal({ resumeUploaded }) {
  const defaultInput = {
    name: "",
    mobile: "Not Needed",
    email: "Not Needed",
    tags: "",
    };
    const [formInput, setFormInput] = useState(defaultInput);
    const [currentMsg, setResponse] = useState("");
    const { value } = useParams();
    const { nujobsGetMyResumes} = useNuJobDetailsStore();    
    const { isCandidateModalOpen, handleModalOk, handleModalCancel } =
        useNuJobsResumeAddModalStore();

    const [form] = Form.useForm();        
    const userDetails = JSON.parse(localStorage.getItem("nujobsUserDetails"));

    const baseURL = API_URL;

    const props = {
        
        showUploadList: true,
        name: "pdf",
        action: `${baseURL}/nujobsaddresume/${userDetails.nujoid}/${userDetails.nujuid}`,

        maxCount: 1,
        data: {
            name: formInput?.name,
            mobile: "Not Needed",
            email: "Not Needed",
            tags: formInput?.tags,
        },
        beforeUpload() {
            const { name,tags } = formInput;
            if (name === "") {
                message.error(`Please Enter the Resume Name`);
                return false;
            }
            if (tags === "") {
                message.error(`Please Enter the Skills`);
                return false;
            }            
        },
        onChange(info) {
            if (info.file.status !== "uploading") {
               // console.log(info);
            }
            if (info.file.status === "done") {
                //now check if 

                //response: '{"status": "success"}', // response from server
                var responseData = info.file.response
                message.success(`${info.file.name} file uploaded successfully`);
                setResponse("Resume Uploaded");
                handleModalOk();  
                form.resetFields();  
                nujobsGetMyResumes(); 

            } else if (info.file.status === "error") {
                message.error(`${info.file.name} file upload failed.`);
                handleModalOk();
                form.resetFields(); 
            }
        },
    };

    const handleFormInput = (event) => {
        setFormInput((inputs) => ({
            ...inputs,
            [event.target.name]: event.target.value,
        }));
    };

    return (
        <Modal
            title="Upload Resume"
            open={isCandidateModalOpen}
            footer={null}
            onCancel={handleModalCancel}
            info={"Uploading resume will replace the existing resume"}
        >
            <Form
                labelCol={{ flex: "150px" }}
                form={form}
                labelAlign="left"
                labelWrap
                wrapperCol={{ flex: 1 }}
                colon={false}
            >
                <Form.Item
                    label="Resume Name"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: "Please input resume name!",
                        },
                    ]}
                >
                    <Input
                        name="name"
                        value={formInput.name}
                        onChange={handleFormInput}                        
                        className="candidateAddModel-input"
                    />
                </Form.Item>

                <Form.Item
                    label="Skills"
                    name="tags"
                    rules={[
                        {
                            required: true,
                            message: "Please input skills!",
                        },
                    ]}                    
                >
                    <Input
                        name="tags"
                        value={formInput.tags}
                        onChange={handleFormInput}
                        placeholder={"skill1,..., skill N etc."}                        
                        className="candidateAddModel-input"
                    />
                </Form.Item>    
                {resumeUploaded && (
                <Alert
                    message="Uploading resume will replace the existing resume"
                    type="warning"
                    showIcon
                    closable
                    style={{ marginBottom: 16 }}
                />
                )}
                <Upload {...props}>
                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
            </Form>
        </Modal>
    );
}
